import React from "react";
import "./Spinner.css";

function Spinner() {
  return (
    <div className="spinnerContainer">
      <div className="spinner"></div>
    </div>
  );
}

export default Spinner;
